<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Payment Processing Options</h1>
    <p>As part of your payroll service, we can make payments on your behalf — including:</p>
    <ul>
      <li>Employee wages (direct to employees’ bank accounts)</li>
      <li>Payments to HMRC (such as tax, National Insurance, and student loans)</li>
    </ul>
    <p>You can choose which payments you'd like us to handle for you. Just tick the options below that apply to your business.</p>
    </div>
    <div class="cell small=8">
        <form class="fieldset" @submit.prevent> 
          <label class="custom-check">
            <input type="checkbox" v-model="formData.employeePayments">I would like Qtac to process my employee payments<span class="checkmark"></span>
          </label> 
          <label class="custom-check">
            <input type="checkbox" v-model="formData.hmrcPayments">I would like Qtac to process my HMRC payments<span class="checkmark"></span>
          </label> 
        </form>
    </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.employeePayments && !props.formData.hmrcPayments) {
    error.value.push('Please select at least one payment processing option.');
  }

  if (error.value.length > 0) return false;

  return true;
}




const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>